import { motion } from "framer-motion";
import GithubStats from '../GithubStats/GithubStats';
import Divider from "./Divider";
import FooterBottom from "./FooterBottom";
import FooterHeading from "./FooterHeading";
import SocialLinks from "./SocialLinks";
import WakatimeStats from "./WakatimeStats";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-green-900"
    >
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <FooterHeading />
        <Divider />
        <SocialLinks />
        <GithubStats />
        <WakatimeStats />
        <FooterBottom currentYear={currentYear} />
      </div>
    </motion.footer>
  );
};

export default Footer;
